import { render } from "./SocialAuthBtn.vue?vue&type=template&id=97ee331a"
import script from "./SocialAuthBtn.vue?vue&type=script&lang=js"
export * from "./SocialAuthBtn.vue?vue&type=script&lang=js"

import exportComponent from "/trc/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__